import React, { useState } from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs, VStack } from '@chakra-ui/react';
import { Tile } from '@/components/Tile';

import FacultyEditor from '@/components/pages/Admin/Faculty/FacultyEditor';
import OrganisationEditor from '@/components/pages/Admin/Faculty/OrganisationEditor';
import WorkdayUpload from '@/components/pages/Admin/Faculty/WorkdayUpload';

const FacultyOrganisationEditor = () => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Tile
            colspan={3}
            heading={'Faculties and Organisation Units'}
            collapsable
            rounded={'lg'}
            borderWidth={1}
            borderColor={'gray.100'}
        >
            <VStack alignItems={'flex-start'} spacing={3} w="full">
                <WorkdayUpload />
                <Tabs isLazy index={tabIndex} onChange={setTabIndex} w="full">
                    <TabList>
                        <Tab>Faculties</Tab>
                        <Tab>Organisation Units</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel px={0}>
                            <FacultyEditor />
                        </TabPanel>
                        <TabPanel px={0}>
                            <OrganisationEditor />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </VStack>
        </Tile>
    );
};

export default FacultyOrganisationEditor;
